define(
//begin v1.x content
({
	buttonOk: "OK",
	buttonCancel: "Tühista",
	buttonSave: "Salvesta",
	itemClose: "Sulge"
})
//end v1.x content
);
